// src/api/users.ts
import api from './axios';
import {
    User,
    CreateUserRequest,
    UpdateUserRequest
} from '../types/user';

export async function getUsers(): Promise<User[]> {
    const res = await api.get<User[]>('/users');
    return res.data;
}
export async function createUser(
    data: CreateUserRequest
): Promise<User> {
    const res = await api.post<User>('/users', data);
    return res.data;
}
export async function updateUser(
    id: string,
    data: UpdateUserRequest
): Promise<User> {
    const res = await api.patch<User>(`/users/${id}`, data);
    return res.data;
}
export async function deleteUser(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
}

// New: change password
export async function changePassword(
    id: string,
    newPassword: string
): Promise<void> {
    await api.patch(`/users/${id}/password`, { newPassword });
}
